import { IUserGaData } from '../../types/user';
import { ISopr1Partner } from '../../types/analytics';

export function getCriteo(
  userGaData?: IUserGaData,
): Pick<ISopr1Partner, 'CriteoEmail' | 'CriteoNewCustomer' | 'CriteoProducts'> {
  return {
    CriteoEmail: (userGaData && userGaData.criteoEmail) || undefined,
    CriteoNewCustomer: userGaData && String(userGaData.criteoNewCustomer),
  };
}
